<template>
  <div>
    <SchemaField
      v-for="(item, index) in insightField"
      :key="index"
      v-model="formState[item.field]"
      :schema="item"
      @change="
        item?.onChange
          ? item?.onChange($event, formState)
          : handleChangeField(item.field, $event)
      "
    />
    <div style="position: relative">
      <SchemaField v-model="questions" :schema="questionsfieldSchema" />
      <div style="position: absolute; right: 20px; top: -5px">
        <van-button type="info" icon="question" size="mini" plain round @click="showPopup = true">KIT释义</van-button>
        <van-popup v-model="showPopup" position="bottom" :style="{ height: '100%' }">
          <div style="display: flex; align-items: center; justify-content: space-between; padding: 5px 15px;">
            <div style="font-size: 18px; margin-top: 5px; color: #ccc">KIT释义</div>
            <div><van-icon name="close" size="24px" @click="showPopup = false" /></div>
          </div>
          <van-tree-select
            :items="KITKIQOptions"
            :main-active-index.sync="activeIndex"
            :style="{ height: 'calc(100% - 80px)', 'text-align': 'left' }"
          >
            <template #content>
              <div v-if="currentKIT" class="current-kit">
                <h2 class="kit-subject">{{ currentKIT.topic_name }}</h2>
                <div v-if="currentKIT.objective">
                  <h3 class="kit-title">目标</h3>
                  <div>{{ currentKIT.objective }}</div>
                </div>
                <div v-if="currentKIT.insight_topic__insight_questions">
                  <h3 class="kit-title">KIQ</h3>
                  <ul class="kit-list">
                    <li v-for="(item, index) in currentKIT.insight_topic__insight_questions" :key="index">
                      <div class="mb-2">
                        <div>{{ item.question }}</div>
                        <ul class="kit-list">
                          <li
                            v-if="item.expected_answer"
                            class="circle"
                          >
                            <span>预期回复：</span><i>{{ item.expected_answer }}</i>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-if="currentKIT.background">
                  <h3 class="kit-title">背景信息</h3>
                  <ul class="kit-index">
                    <li v-for="(info, index) in currentKIT.background?.split('\n')" :key="index">
                      {{ index + 1 }}. {{ info }}
                    </li>
                  </ul>
                </div>
                <div v-if="currentKIT.references">
                  <h3 class="kit-title">索引</h3>
                  <ul class="kit-index">
                    <li v-for="(reference, index) in currentKIT.references?.split('\n')" :key="index">
                      {{ index + 1 }}. {{ reference }}
                    </li>
                  </ul>
                </div>
              </div>

            </template>
          </van-tree-select>
        </van-popup>
      </div>
    </div>
    <SchemaField
      v-if="KIQLabel.length"
      :schema="{label: 'KIQ标签'}"
      :value-border="false"
    >
      <div>
        <van-button
          v-for="(item, index) in KIQLabel"
          :key="index"
          type="primary"
          size="mini"
          round
          style="padding: 0 14px"
        >{{ item }}</van-button>
      </div>
    </SchemaField>
    <SchemaField :schema="{label: '反馈内容'}">
      <div
        ref="feedbackContentRef"
        style="width: 100%; min-height: 100px"
        contenteditable
        @input="updateContent"
        @compositionstart="inComposition = true"
        @compositionend="
          inComposition = false;
          updateContent($event);
        "
        v-html="feedbackContentHighlight"
      ></div>
    </SchemaField>
    <SpeechToText @translateResult="feedbackContent += $event" @recordComplete="handleRecordComplete" />
    <div v-if="localId" style="margin-top: 10px; text-align: center;">
      <van-button icon="play-circle-o" type="info" size="small" round @click="playVoice">播放录音</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Tab, Tabs, Picker, Popup, Icon, Button} from 'vant';
import SchemaField from './SchemaField.vue';
import {fetchInsightQuestionLabels} from '@/api/kol';
import kvpKeyMixin from '@/mixins/kvpKey';
import SpeechToText from '@/components/SpeechToText.vue';
import {flatten} from 'lodash';
import {getLocalStorage} from '@/utils/index';
import {wecomSDK} from '@/utils/wecom';
import {
  createEditPhysicianMslInsightQuestions,
  deletePhysicianMslInsightQuestions,
} from '@/api/kol';
import {validateFields} from '@/views/kol/util';

Vue.use(Popup);
Vue.use(Picker);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Button);

export default {
  components: {SchemaField, SpeechToText},
  mixins: [kvpKeyMixin('product_or_disease'), kvpKeyMixin('ta')],
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    insightTopicList: Array,
    initQuestions: Array,
  },

  data() {
    return {
      formState: {
        // insight_question_id: '',
        insight_topic_id: '',
        product: '',
        product_id: '',
      },
      feedbackContent: '',
      localId: '',
      KIQLabel: [],
      questions: [],
      products: [],
      showPopup: false,
      activeIds: [],
      activeIndex: 0,
    };
  },
  computed: {
    KITKIQList() {
      const list = flatten(
        this.insightTopicList?.map((item) => {
          return item?.insight_topic__insight_questions.map((questionItem) => ({
            insight_dimension_id: item.insight_dimension?.insight_dimension_id,
            dimension_name: item.insight_dimension?.dimension_name,
            topic_name: item.topic_name,
            insight_topic_id: item.insight_topic_id,
            question: questionItem.question,
            insight_question_id: questionItem.insight_question_id,
          }));
        }),
      );

      list.push(
        ...this.initQuestions.map(
          ({physician_msl_insight_question_id, ...item}) => item,
        ),
      );

      return list;
    },
    KITKIQOptions() {
      const insightTopicList = this.insightTopicList?.map((item) => ({
        text: item.topic_name,
        id: item.insight_topic_id,
        children: item.insight_topic__insight_questions.map((item) => ({
          text: item.question,
          id: item.insight_question_id,
        })),
      }));

      console.log(insightTopicList, this.initQuestions, 'call');
      // 选项中不存在值，添加到选项中, 保证可以显示
      insightTopicList &&
        this.initQuestions?.forEach((item) => {
          const findTopic = insightTopicList.find((tropicItem) => {
            return tropicItem.id === item.insight_topic_id;
          });
          if (findTopic) {
            const findQuestion = findTopic.children.find((questionItem) => {
              return questionItem.id === item.insight_question_id;
            });
            if (!findQuestion) {
              findTopic.children.push({
                id: item.insight_question_id,
                text: item.question,
              });
            }
          } else {
            insightTopicList.push({
              id: item.insight_topic_id,
              text: item.topic_name,
              children: [
                {
                  id: item.insight_question_id,
                  text: item.question,
                },
              ],
            });
          }
        });

      return insightTopicList;
    },
    currentKIT() { // KIT释义中选中的KIT
      return this.insightTopicList?.find(
        (item) => item.insight_topic_id === this.KITKIQOptions[this.activeIndex]?.id,
      );
    },
    optionsKIT() {
      return this.insightTopicList?.map((item) => ({
        text: item.topic_name,
        id: item.insight_topic_id,
      }));
    },
    optionsKIQ() {
      return this.insightTopicList
        ?.find(
          (item) => item.insight_topic_id === this.formState.insight_topic_id,
        )
        ?.insight_topic__insight_questions?.map((item) => ({
          text: item.question,
          id: item.insight_question_id,
        }));
    },
    resultFormState() {
      return {
        insight_question_id: this.formState.insight_question_id,
        insight_content: this.feedbackContent,
        product: this.formState.product,
        product_id: this.formState.product_id,
        ta: this.formState.ta,
        ta_id: this.formState.ta_id,
      };
    },
    questionsfieldSchema() {
      return {
        field: 'questions',
        type: 'treeSelect',
        label: 'KIT/KIQ',
        onChange: (e, form) => {},
        options: this.KITKIQOptions,
      };
    },
    insightField() {
      return [
        {
          field: 'product',
          type: 'select',
          label: '产品或疾病',
          onChange: (e, form) => {
            const target = this.products.find(
              (item) => item.kvp_key_name === e,
            );
            form.product_id = target.kvp_key_id;
            form.ta_id = target.parent_kvp_key_id;
            form.ta = this.ta.find((item) => item.kvp_key_id === form.ta_id)?.kvp_key_name;
            console.log('ta', form.ta_id, form.ta);
          },
          options: this.products.map((item) => item.kvp_key_name),
          required: true,
        },
        // {
        //   field: 'insight_topic_id',
        //   label: 'KIT',
        //   type: 'select',
        //   options: this.optionsKIT,
        // },
        // {
        //   field: 'insight_question_id',
        //   label: 'KIQ',
        //   type: 'select',
        //   options: this.optionsKIQ,
        // },
      ];
    },
    feedbackContentHighlight() {
      let result = this.feedbackContent;
      this.KIQLabel.forEach((item) => {
        if (!result) return;
        result = result.replaceAll(
          item,
          `<span class="highlight">${item}</span>`,
        );
      });
      return result;
    },
  },
  watch: {
    initQuestions: {
      immediate: true,
      handler(val) {
        this.questions = val?.map((item) => item.insight_question_id);
      },
    },
    'formState.insight_question_id'(val) {
      console.log(val, 'change formstate');
      if (!val) return;
      this.fetchInsightQuestionLabels(val);
    },
    resultFormState(newValue, oldValue) {
      this.$emit('input', newValue);
    },
    product_or_disease(val) {
      const tas = getLocalStorage('tas');
      if (tas) {
        const taList = tas.split(',');
        this.products = val.filter(
          (item) => taList.indexOf(item.parent_kvp_key_id) >= 0,
        );
      }
      console.log('product_or_disease', val, this.products);
    },
    value: {
      handler(val) {
        this.feedbackContent = val.insight_content;

        try {
          this.formState.product = val.product;
          this.formState.product_id = val.product_id;
          this.formState.insight_question_id =
            val.insight_question.insight_question_id || val.insight_question_id;
          this.formState.insight_topic_id =
            val.insight_question.insight_topic_id;
          this.formState.ta = val.ta;
          this.formState.ta_id = val.ta_id;
        } catch (err) {
          return;
        }
      },
      immediate: true,
    },
  },
  // 处理中文输入,
  inComposition: false,

  methods: {
    handleRecordComplete({localId, translateResult}) {
      this.localId = localId;
      // Here we could apply summarization logic if we had an API.
      // For now, we just use the translated result.
      // this.feedbackContent += translateResult; // Already handled by @translateResult
    },
    playVoice() {
      if (this.localId) {
        wecomSDK.playVoice(this.localId);
      }
    },
    async fetchInsightQuestionLabels(id) {
      const res = await fetchInsightQuestionLabels(id);
      this.KIQLabel = res.map((item) => item.label_name);
    },

    updateContent(e) {
      if (this.inComposition) {
        return;
      }
      const input = this.$refs.feedbackContentRef;
      var position = getCaretCharacterOffsetWithin(input);
      console.log(position, 'position');
      this.feedbackContent = e.target.innerText;
      this.$nextTick(() => {
        setCaretPosition(input, position);
      });
    },
    handleChangeField(field, value) {
      if (field === 'insight_topic_id') {
        this.$nextTick(() => {
          this.formState.insight_question_id = this.optionsKIQ[0].id;
        });
      }
      console.log(field, value, 'field change');
    },
    async saveInsightQuestions(physician_msl_insight_id) {
      // 删除所有旧的关系
      if (this.initQuestions?.length) {
        await deletePhysicianMslInsightQuestions(
          this.initQuestions?.map(
            (item) => item.physician_msl_insight_question_id,
          ),
        );
      }
      const saveList =
        this.questions?.map((questionId) =>
          this.KITKIQList.find(
            (item) => questionId === item.insight_question_id,
          ),
        ) || [];

      // 添加所有新的关系
      await Promise.all(
        saveList?.map((item) =>
          createEditPhysicianMslInsightQuestions({
            physician_msl_insight_id,
            ...item,
          }),
        ),
      );
    },
    validateForm() {
      return validateFields(this.insightField, this.formState);
    },
  },
};

function getCaretCharacterOffsetWithin(element) {
  var caretOffset = 0;
  var doc = element.ownerDocument || element.document;
  var win = doc.defaultView || doc.parentWindow;
  var sel;
  if (typeof win.getSelection !== 'undefined') {
    sel = win.getSelection();
    if (sel.rangeCount > 0) {
      var range = win.getSelection().getRangeAt(0);
      var preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(element);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      caretOffset = preCaretRange.toString().length;
    }
  } else if ((sel = doc.selection) && sel.type !== 'Control') {
    var textRange = sel.createRange();
    var preCaretTextRange = doc.body.createTextRange();
    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint('EndToEnd', textRange);
    caretOffset = preCaretTextRange.text.length;
  }
  return caretOffset;
}

function setCaretPosition(element, offset) {
  var range = document.createRange();
  var sel = window.getSelection();

  // select appropriate node
  var currentNode = null;
  var previousNode = null;

  for (var i = 0; i < element.childNodes.length; i++) {
    // save previous node
    previousNode = currentNode;

    // get current node
    currentNode = element.childNodes[i];
    // if we get span or something else then we should get child node
    while (currentNode.childNodes.length > 0) {
      currentNode = currentNode.childNodes[0];
    }

    // calc offset in current node
    if (previousNode != null) {
      offset -= previousNode.length;
    }
    // check whether current node has enough length
    if (offset <= currentNode.length) {
      break;
    }
  }
  // move caret to specified offset
  if (currentNode != null) {
    range.setStart(currentNode, offset);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  }
}
</script>

<style lang="scss" scoped>
::v-deep .highlight {
  background-color: #24e57e;
}

::v-deep .display-item {
  background-color: #d8e4fc;
  margin-top: 0.16rem;
  border-radius: 0.106667rem !important;
}

::v-deep .display-container {
  margin-top: -0.16rem;
}

::v-deep .van-field__label {
  width: auto;
}

.current-kit {
  padding: 0 10px;
  line-height: 1.3;

  .kit-subject {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin-top: 20px;
  }
  .kit-title {
    font-size: 14px;
    font-weight: bold;
    color: #00b852;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .kit-list {
    font-size: 13px;
    li {
      list-style: disc;
      margin-left: 15px;
      line-height: 1.3;
      margin-bottom: 5px;
    }
    li.circle {
      list-style: circle
    }
  }

  .kit-content,
  .kit-index {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .kit-content li,
  .kit-index li {
    font-size: 12px;
    line-height: 1.3;
    color: #333;
    margin-bottom: 5px;
  }
}
</style>
